{
  "name": "prometeo",
  "version": "4.30.0",
  "description": "OKN's Learning Management System",
  "main": "index.js",
  "type": "module",
  "dependencies": {
    "@bugsnag/js": "^8.10.0",
    "@bugsnag/plugin-vue": "^8.9.0",
    "@date-fns/tz": "^1.5.0",
    "@microsoft/teams-js": "2.27.0",
    "@popperjs/core": "^2.11.8",
    "@vitejs/plugin-vue": "^6.0.8",
    "@vuelidate/core": "^2.0.3",
    "@vuelidate/validators": "^2.0.4",
    "@vueuse/core": "^14.4.0",
    "aphrodite": "^2.4.0",
    "axios": "^1.20.0",
    "bootstrap": "^4.6.2",
    "bowser": "^2.14.1",
    "canvas-confetti": "^1.9.4",
    "date-fns": "^4.1.0",
    "duration-fns": "^3.0.2",
    "eslint-plugin-vue": "^10.9.2",
    "firebase": "^12.13.0",
    "front-toolkit": "github:okn/front-toolkit#v2.13.0",
    "highcharts": "^13.0.2",
    "highcharts-pattern-fill": "^3.0.3",
    "highcharts-vue": "^2.0.1",
    "js-cookie": "^3.0.8",
    "lodash": "^4.18.1",
    "mjml": "~5.4.0",
    "normalizr": "^3.6.2",
    "pdfjs-dist": "^6.3.289",
    "pinia": "^4.0.3",
    "popper.js": "^1.16.1",
    "recaptcha-v3": "^1.11.3",
    "scorm-again": "github:okn/scorm-again#v1.12.0",
    "tinycolor2": "^1.6.0",
    "url-join": "^5.0.0",
    "v-calendar": "3.0.0",
    "vue": "^3.5.13",
    "vue-advanced-cropper": "^2.8.9",
    "vue-gtag": "^3.7.0",
    "vue-i18n": "^9.14.5",
    "vue-router": "^5.3.0",
    "vue3-mq": "^4.1.0",
    "vuex": "^4.1.0"
  },
  "devDependencies": {
    "@eslint/js": "^9.39.0",
    "@ngneat/falso": "^8.0.2",
    "@pinia/testing": "^2.0.1",
    "@vitest/coverage-v8": "^4.1.11",
    "@vue/test-utils": "^2.4.6",
    "@vue/tsconfig": "^0.9.1",
    "autoprefixer": "^10.5.4",
    "eslint": "^10.9.1",
    "eslint-config-prettier": "^10.1.8",
    "globals": "^17.11.0",
    "jsdom": "^26.1.0",
    "postcss": "^8.5.25",
    "prettier": "^3.9.6",
    "rollup": "^4.63.1",
    "sass-embedded": "^1.103.1",
    "sinon": "^22.1.0",
    "tailwindcss": "^3.4.19",
    "typescript": "^6.0.3",
    "vite": "^8.2.2",
    "vitest": "^4.0.6",
    "vue-tsc": "^3.3.11"
  },
  "scripts": {
    "serve": "vite",
    "watch": "vite build --watch",
    "build": "vite build",
    "test": "vitest",
    "test:ci": "vitest --run --reporter junit --outputFile.junit=test-results.xml",
    "lint": "eslint --fix src admin unittests",
    "format": "prettier --write src admin unittests"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/okn/prometeo.git"
  },
  "author": "Open Knowledge Network",
  "license": "UNLICENSED",
  "private": true
}
